import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'

function ConfirmEmail() {
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState('')
  const [resending, setResending] = useState(false)
  const [resendSuccess, setResendSuccess] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    // Get email from URL params or from session
    const emailParam = searchParams.get('email')
    if (emailParam) {
      setEmail(emailParam)
    } else {
      // Try to get from current session
      supabase.auth.getSession().then(({ data: { session } }) => {
        if (session?.user?.email) {
          setEmail(session.user.email)
        }
      })
    }
  }, [searchParams])

  const handleResendEmail = async () => {
    if (!email) {
      setError('Email address not found. Please sign up again.')
      return
    }

    setResending(true)
    setError('')
    setResendSuccess(false)

    try {
      const { error: resendError } = await supabase.auth.resend({
        type: 'signup',
        email: email,
        options: {
          emailRedirectTo: `${window.location.origin}/dashboard`
        }
      })

      if (resendError) throw resendError

      setResendSuccess(true)
    } catch (err) {
      console.error('Error resending email:', err)
      setError(err.message || 'Failed to resend confirmation email')
    } finally {
      setResending(false)
    }
  }

  return (
    <div className="container" style={{ paddingTop: '60px' }}>
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
        {/* Icon */}
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>📧</div>

        {/* Heading */}
        <h2 style={{ fontSize: '28px', marginBottom: '15px', color: '#2c3e50' }}>
          Check Your Email
        </h2>

        {/* Description */}
        <p style={{ fontSize: '16px', color: '#7f8c8d', marginBottom: '25px', lineHeight: '1.6' }}>
          We've sent a confirmation email to:
        </p>

        {/* Email display */}
        {email && (
          <div style={{
            background: '#f8f9fa',
            padding: '15px 20px',
            borderRadius: '8px',
            marginBottom: '25px',
            fontSize: '16px',
            fontWeight: '600',
            color: '#2c3e50',
            wordBreak: 'break-word'
          }}>
            {email}
          </div>
        )}

        {/* Instructions */}
        <div style={{
          background: '#e3f2fd',
          border: '1px solid #90caf9',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '25px',
          textAlign: 'left'
        }}>
          <h3 style={{ fontSize: '16px', marginBottom: '12px', color: '#1565c0' }}>
            Next Steps:
          </h3>
          <ol style={{ margin: 0, paddingLeft: '20px', color: '#1976d2', lineHeight: '1.8' }}>
            <li>Open the email from Krinos AI</li>
            <li>Click the "Confirm your email" button</li>
            <li>You'll be redirected to sign in</li>
            <li>Start creating assessments!</li>
          </ol>
        </div>

        {/* Success message */}
        {resendSuccess && (
          <div style={{
            background: '#d4edda',
            border: '1px solid #c3e6cb',
            color: '#155724',
            padding: '12px 20px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}>
            ✓ Confirmation email sent! Check your inbox.
          </div>
        )}

        {/* Error message */}
        {error && (
          <div className="error" style={{ marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {/* Resend button */}
        <button
          onClick={handleResendEmail}
          disabled={resending || !email}
          className="btn btn-secondary"
          style={{ width: '100%', marginBottom: '15px' }}
        >
          {resending ? 'Sending...' : 'Resend Confirmation Email'}
        </button>

        {/* Help text */}
        <p style={{ fontSize: '14px', color: '#95a5a6', marginBottom: '20px' }}>
          Didn't receive the email? Check your spam folder or click the button above to resend.
        </p>

        {/* Divider */}
        <div style={{ borderTop: '1px solid #e0e0e0', margin: '25px 0' }}></div>

        {/* Sign in link */}
        <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '10px' }}>
          Already confirmed your email?
        </p>
        <button
          onClick={() => navigate('/login')}
          className="btn btn-primary"
          style={{ width: '100%' }}
        >
          Sign In →
        </button>
      </div>
    </div>
  )
}

export default ConfirmEmail
